import { deleteTo } from "src/store/dataService/routes/shared/osfetch";
import { forgetLocalDealState } from "src/utils/localStorage";

export const deleteGarage = async (uuid: string, slug: string, env: string) => {
    const response = await deleteTo(`/demo/deal/${uuid}`, {});
    forgetLocalDealState({ slug, env });
    return response.ok;
};

export const signOut = (slug: string, env: string) => {
    forgetLocalDealState({ slug, env });
};
